import { useEffect } from 'react';
import { useTemplateEditorState } from '../context/UseTemplateEditorContext';
import { useIsOnsiteArea } from './useIsOnsiteArea';
import { useOffsitePreview } from './useOffsitePreview';
import { useOnsitePreview } from './useOnsitePreview';

export const useInitialPreviewTemplate = () => {
  const { initialPreviewRan, template } = useTemplateEditorState();

  const offsitePreview = useOffsitePreview();
  const onsitePreview = useOnsitePreview();
  const isOnsiteArea = useIsOnsiteArea();

  useEffect(() => {
    if (initialPreviewRan || !template.id) {
      return;
    }

    if (isOnsiteArea) {
      onsitePreview();
    } else {
      offsitePreview();
    }
  }, [initialPreviewRan, isOnsiteArea, offsitePreview, onsitePreview, template.id, template.template]);
};
